import { useState } from "react";
import { ImageOff } from "lucide-react";

interface ImageProps {
  src: string;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
}

export function Image({ src, alt, className, fallback = null }: ImageProps) {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      fallback || (
        <div
          className={`flex items-center justify-center ${className || ""} bg-background-highlight p-2`}
        >
          <ImageOff
            className="w-[40%] h-[40%] text-text-secondary"
            strokeWidth={1}
          />
        </div>
      )
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        setHasError(true);
      }}
    />
  );
}
